import cn from 'classnames';
import type { FC } from 'react';

import { Text, Heading, Link } from '@sravni/react-design-system/lib/Typography';

import stepsConfettiSrc from '@src/assets/octoberPrizeDraw/stepsConfetti.png';
import { OptimizedPicture } from '@src/components/ui/OptimizedPicture';

import styles from './styles.module.scss';

interface Props {
  title: string;
  description: string;
  iconSrc: string;
  confettiImageClassName: string;
}

export const OctoberPrizeDrawHistory: FC<Props> = ({ title, description, iconSrc, confettiImageClassName }) => (
  <div className={styles.container}>
    <OptimizedPicture imgClassName={styles.mainImage} img={iconSrc} alt="" />

    <div className={styles.rightContent}>
      <Heading level={5} className={styles.title}>
        {title}
      </Heading>
      <Text size={12} className="h-color-D60">
        {description}
      </Text>
    </div>

    <OptimizedPicture imgClassName={cn(styles.confettiImage, confettiImageClassName)} img={stepsConfettiSrc} alt="" />
  </div>
);
